import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const AssignmentsLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.assignment',
    link: '/followed/tab',
    icon: 'navigation-link__list-item',
});